
import Vue, { PropType } from 'vue';
import { UiMenuItem } from '@/model';

export default Vue.extend({
  name: 'MenuTreeItem',

  props: {
    item: {
      type: Object as PropType<UiMenuItem>,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
    parentKey: {
      type: String,
      required: true,
    },
  },

  computed: {
    hasChildren(): boolean {
      return Boolean(this.item.children && this.item.children.length > 0);
    },
    groupValue(): boolean {
      return this.depth > 0 || this.isGroupActive;
    },
    isGroupActive(): boolean {
      return this.isSelected(this.item);
    },
  },

  methods: {
    childKey(item: UiMenuItem, index: number): string {
      return `${this.parentKey}-${index}-${item.title}`;
    },
    isSelected(item: UiMenuItem): boolean {
      if (item.route && this.$route.path === item.route) {
        return true;
      }
      return (item.children ?? []).some((child) => this.isSelected(child));
    },
  },
});
